module.exports = __webpack_public_path__ + "img/Publish-th.daf8526.png";